import { RevenueChart } from "./charts/revenueline";

export default function DashboardCharts() {
  return (
    <div className="w-full mb-4 sm:mb-8 grid grid-cols-1">
      <RevenueChart />
    </div>
  );
}
